<template>
  <PageContainer title="Produtos e Serviços">
    <div slot="header">
      <Button type="button" @handle:click="() => openFormModal('create')" text="Adicionar" color="secondary"
        :disabled="loading" title="Adicionar novo produto/serviço">
        <Plus :size="18" />
      </Button>
    </div>

    <Box space="medium" class="container-box">
      <form @submit.prevent="handleSubmit">
        <div class="inputs">
          <div class="inputs-row">
            <Input legend="Nome" placeholder="Digite o nome do produto/serviço" :modelValue="nomeProduto"
              @update:modelValue="$event => nomeProduto = $event" class="input-full" />

            <Select class="input-full" :options="sortByOptions" legend="Ordernar por" :modelValue="sortBy"
              @update:modelValue="$event => (sortBy = $event)" :disabled="loading" />

            <Select class="input-full" :options="orderOptions" legend="Direção" :modelValue="order"
              @update:modelValue="$event => (order = $event)" :disabled="loading" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="d-flex justify-content-center" v-if="loading">
        <LoadingSpinner />
      </div>

      <div class="table-container" v-else>
        <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
          @page-changed="fetchProdutos" />

        <Table :headers="['Nome', 'Valor', 'Data de criação', 'Ações']">
          <tr v-if="!products.length">
            <td colspan="4">
              <div class="text-center">
                Nenhum produto/serviço encontrado.
              </div>
            </td>
          </tr>
          <tr v-for="produto in products" :key="produto.id">
            <td>{{ produto.name }}</td>
            <td>{{ utils.formatarValor(produto.value / 100) }}</td>
            <td>{{ utils.formatDate(produto.created_at) }}</td>
            <td>
              <div class="actions">
                <div>
                  <IconButton @handle:click="() => openFormModal('edit', produto)" color="primary" title="Editar"
                    :disabled="loadingActions">
                    <PencilOutline :size="19" />
                  </IconButton>
                </div>
                <div>
                  <IconButton @handle:click="openDeleteModal(produto.id)" color="danger" title="Remover"
                    :disabled="loadingActions">
                    <TrashCanOutline :size="19" />
                  </IconButton>
                </div>
              </div>
            </td>
          </tr>
        </Table>
      </div>
    </Box>

    <ProdutosServicosFormModal ref="formModal" @refresh="fetchProdutos(paginationData.currentPage)" />

    <ConfirmModal ref="confirmModal" title="Remover produto/serviço"
      message="Tem certeza que deseja remover esse produto/serviço? esta ação é irreversível e o produto/serviço não poderá ser recuperado!"
      :onConfirm="deleteProduto" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Button from 'core/Button'
import Paginate from 'core/Paginate'
import Table from 'core/Table'
import IconButton from 'core/IconButton'
import ConfirmModal from 'core/ConfirmModal'
import LoadingSpinner from 'core/LoadingSpinner'
import Input from 'core/Input'
import Select from 'core/Select'
import Plus from 'icons/Plus'
import PencilOutline from 'icons/PencilOutline'
import TrashCanOutline from 'icons/TrashCanOutline'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'


import ProdutosServicosFormModal from './ProdutosServicosFormModal'
import utils from '../../services/utils'

export default {
  name: "ProdutosServicos",
  components: {
    PageContainer,
    Box,
    Button,
    Paginate,
    Table,
    IconButton,
    ConfirmModal,
    LoadingSpinner,
    Input,
    Select,

    Plus,
    PencilOutline,
    TrashCanOutline,
    CloseCircleOutline,
    Magnify,

    ProdutosServicosFormModal,
  },
  data() {
    return {
      utils: utils,
      nomeProduto: '',
      sortBy: 'name',
      order: 'asc',
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      products: [],
      sortByOptions: [
        { value: 'created_at', text: 'Data de Criação' },
        { value: 'name', text: 'Nome' },
        { value: 'value', text: 'Valor' },
      ],
      orderOptions: [
        { value: 'asc', text: 'A-Z' },
        { value: 'desc', text: 'Z-A' },
      ],
      loading: false,
      loadingActions: false,
    }
  },
  async created() {
    await this.fetchProdutos()
  },
  methods: {
    async fetchProdutos(page = 1) {
      this.loading = true

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/produtos?page=${page}${this.nomeProduto ? `&filter=${this.nomeProduto}` : ''}${this.sortBy ? `&sort_by=${this.sortBy}` : ''}${this.order ? `&order=${this.order}` : ''}`)
        .then(response => {
          this.products = response.body.dados.data

          this.paginationData.currentPage = response.body.dados.current_page
          this.paginationData.lastPage = response.body.dados.last_page
          this.paginationData.total = response.body.dados.total
        })
        .catch(error => {
          this.$toasted.show('Erro ao buscar produtos/serviços.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSubmit() {
      await this.fetchProdutos(this.paginationData.currentPage)
    },
    openFormModal(type, product = null) {
      this.$refs.formModal.open(type, product)
    },
    openDeleteModal(id) {
      this.$refs.confirmModal.open(id)
    },
    async deleteProduto(produto) {
      this.loading = true

      this.$refs.confirmModal.close()

      await this.$http.delete(`${process.env.VUE_APP_URL_API_V2}/produtos/${produto}`)
        .then(async () => {
          this.$toasted.show('Produto/Serviço removido com sucesso!', {
            position: 'top-right',
          })

          await this.fetchProdutos(this.paginationData.currentPage)
        })
        .catch((err) => {
          this.$toasted.show('Erro ao remover produto/serviço.', {
            position: 'top-right',
          })
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInputs() {
      this.nomeProduto = ''
      this.sortBy = 'name'
      this.order = 'asc'
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .inputs-row {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;

      .input-full {
        flex: 1;
      }
    }
  }

  .buttons {
    align-self: flex-end;

    display: flex;
    gap: 0.5rem;
  }
}

.table-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .pagination-container {
    align-self: flex-end;
  }
}

.actions {
  display: flex;
  align-items: center;

  div {
    padding: 0 0.5rem;
    display: flex;
    justify-content: center;

    &:not(:first-child) {
      border-left: 1px solid #ECECEC;
    }

    &:not(:last-child) {
      border-right: 1px solid #ECECEC;
    }
  }
}
</style>